import React, {useCallback, useEffect, useRef, useState} from "react";
import Page from "../../components/general/page";
import {useSelector} from "react-redux";
import { F24_IFRAME_URL, APP_PDC_URL } from "../../config";
import {createHttpHeaderWithAuthorization} from "../../store/services/http-header";

export const useF24Token = (
  workspaceId, auth, openTributes, date
) => {
  const [pending, setPending] = useState(false);
  const [token, setToken] = useState(null);
  const [error, setError] = useState(null);

  const ref = useRef(true);

  const fetchToken = useCallback(async(workspaceId) => {
    setPending(true);

    try {
      const myHeaders = createHttpHeaderWithAuthorization(auth.securityToken);

      const raw = JSON.stringify({
        refreshToken: auth.refreshToken,
        workspaceId: workspaceId,
        contesto: openTributes ? {
          deadline: date, // da adempimento
          type: "TRIBUTE" // sempre questo
        } : null
      });

      const response = await fetch(`${APP_PDC_URL}/api/v1/auth/v2`, {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      });
      const tokenRaw = await response.text();
      setToken(tokenRaw);

    } catch (e) {
      setError(e);
    }

    setPending(false);
  },
  [workspaceId, auth.securityToken]);

  useEffect(() => {
    if (ref.current) fetchToken(workspaceId);
  }, [workspaceId, auth.securityToken]);

  useEffect(() => {
    return () => (ref.current = false);
  });

  return {pending, token, error};
};

const F24View = (props) => {
  const {pageRef} = props;
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const company = useSelector(state => state.company);
  let actualCompany = company.companies.find((x) => x.uuid === main.companyUuidSelected) || {};
  const {token} = useF24Token(
    actualCompany.workspaceId, auth.loginAuth, false, null
  );

  return (
    <Page
      pageRef={pageRef}
      className={"contentStructure"}
      title={"F24"}
    >
      {token && <iframe style={{border: "none"}} src={`${F24_IFRAME_URL}/?f24token=${token}`} title="f24-dev" height={800}
        width="100%"/>}
    </Page>
  );
};

export default F24View;
